/* eslint-disable no-magic-numbers */
import React from 'react';
import { Text } from '@hub/text';
import { Box } from '@hub/box';
import { LinkBox, LinkOverlay } from '@hub/link';
import { LocationDropPinMediumIcon } from '@hub/icon';
import { CloudinaryImage, IMAGE_SIZES_BROWSE_LIST } from '../cloudinary-image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_DESKTOP_LINES = 2;
const e = encodeURIComponent;
export const StoreListItem = _ref => {
  let {
    centre,
    store,
    onClick
  } = _ref;
  const {
    id,
    slug,
    logoUrl,
    title,
    landmarkDescription,
    longDescription
  } = store;
  const url = "/".concat(e(centre), "/store/").concat(e(id), "/").concat(e(slug));
  return /*#__PURE__*/_jsx(LinkBox, {
    role: "listitem",
    onClick: onClick,
    "data-id": "visible-stores_store-list-item_StoreListItem_LinkBox",
    children: /*#__PURE__*/_jsxs(LinkOverlay, {
      href: url,
      sx: {
        display: 'flex'
      },
      "data-id": "visible-stores_store-list-item_StoreListItem_LinkBox_LinkOverlay",
      children: [/*#__PURE__*/_jsx(Box, {
        sx: {
          marginBottom: 'spacing-sm',
          padding: '8px',
          border: 'solid 1px',
          borderColor: 'ghost'
        },
        "data-id": "visible-stores_store-list-item_StoreListItem_LinkOverlay_Box",
        children: logoUrl ? /*#__PURE__*/_jsx(CloudinaryImage, {
          ratio: "1",
          imageSetOrImage: {
            url: logoUrl,
            type: 'SQUARE'
          },
          minWidth: ['size-11', 'size-md'],
          resizeMode: "pad",
          sizes: IMAGE_SIZES_BROWSE_LIST,
          "data-id": "visible-stores_store-list-item_StoreListItem_CloudinaryImage"
        }) : /*#__PURE__*/_jsx(Box, {
          "aria-hidden": "true",
          sx: {
            backgroundColor: 'smoke',
            overflow: 'hidden',
            height: '0',
            paddingBottom: '100%',
            // set height to currrent width
            width: [80, 128]
          },
          "data-id": "visible-stores_store-list-item_StoreListItem_Box",
          children: /*#__PURE__*/_jsx(Text, {
            sx: {
              margin: '8px',
              fontSize: [10, 14],
              lineHeight: '20px',
              fontWeight: 'bold',
              color: 'ghost'
            },
            "data-id": "visible-stores_store-list-item_StoreListItem_Box_Text",
            children: title
          })
        })
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          flexBasis: '100%',
          marginLeft: 'spacing-md'
        },
        "data-id": "visible-stores_store-list-item_StoreListItem_LinkOverlay_Box",
        children: [/*#__PURE__*/_jsx(Text, {
          sx: {
            fontSize: 'font-md',
            fontWeight: 'bold'
          },
          "data-id": "visible-stores_store-list-item_StoreListItem_Box_Text",
          children: title
        }), landmarkDescription && /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            marginTop: 'spacing-sm',
            color: 'quartz'
          },
          "data-id": "visible-stores_store-list-item_StoreListItem_Box",
          children: [/*#__PURE__*/_jsx(LocationDropPinMediumIcon, {
            sx: {
              marginRight: 'spacing-sm'
            },
            boxSize: "size-icon-sm",
            ariaLabel: "location drop pin icon",
            "data-id": "visible-stores_store-list-item_StoreListItem_Box_LocationDropPinMediumIcon"
          }), /*#__PURE__*/_jsx(Text, {
            sx: {
              fontSize: ['font-sm', 'font-md']
            },
            "data-id": "visible-stores_store-list-item_StoreListItem_Box_Text",
            children: landmarkDescription
          })]
        }), longDescription && /*#__PURE__*/_jsx(Text, {
          noOfLines: MAX_DESKTOP_LINES,
          sx: {
            marginTop: 'spacing-md',
            lineHeight: 'base',
            display: ['none', 'none', 'initial']
          },
          "data-id": "visible-stores_store-list-item_StoreListItem_Text_11",
          children: longDescription
        })]
      })]
    })
  }, id);
};